import React from 'react';
import './HomePage.less';

const HomePage = () => (
  <div className="home-screen">
    <div className="content-intro">
      <h2>Welcome!</h2>
      <h2>Select an option from the left to begin.</h2>
    </div>
  </div>
);

export default HomePage;



// WEBPACK FOOTER //
// ./src/pages/Home/HomePage.js